import React from 'react'
import { InputText } from 'primereact/inputtext';

interface Props {
    value:string|undefined,
    label:string,
    id:string
    loader:boolean

}
const CustomInput = (props:Props) => {
  return (
    <span className="p-float-label p-input-icon-right">
      {props.loader && <i className="pi pi-spin pi-spinner" />}
      <InputText 
          id={props.id} 
          value={props.value}
          disabled
          style={{
            borderBottom: "2px solid #0085ca",
            marginLeft:"6px",
            padding: "0.8vw",
            backgroundColor:"#f4fafe",
            textAlign:"center"  
          }}
      />
        <label htmlFor={props.id} >{props.label}</label>
    </span>    
  )
}
export default CustomInput
